import type { ShiftBreakRecord } from '@libs/data-access/queries'

/**
 * @deprecated file
 */

export const getBreaksInfosLegacy = (
  shiftBreak: ShiftBreakRecord | undefined,
  type: string
) => {
  if (!shiftBreak) {
    return {}
  }

  const typedStart = `${type}_starts_at` as
    | 'planned_starts_at'
    | 'real_starts_at'
  const typeEnd = `${type}_ends_at` as 'planned_ends_at' | 'real_ends_at'
  const typeDuration = `${type}_duration` as
    | 'planned_duration'
    | 'real_duration'

  const dataShiftBreak = shiftBreak?.toJS() ? shiftBreak?.toJS() : shiftBreak

  return {
    plannedDuration: dataShiftBreak.planned_duration,
    realDuration: dataShiftBreak.real_duration,
    shiftEventsSize: dataShiftBreak?.shift_event_ids?.length,
    typeStart: dataShiftBreak[typedStart],
    typeEnd: dataShiftBreak[typeEnd],
    typeDuration: dataShiftBreak[typeDuration],
    eventType: dataShiftBreak.event_type
  }
}
